export default {
  title: 'Delete job values data',
  confirmDelete: {
    header: 'Delete values of "{item}"?',
    message: 'All values from {from} to {to} are deleted. This can\'t be undone.',
  },
};
